(() => {
    'use strict';

    real.events.on('transcribe:processing', notification => {
        if(!notification.object?.uploadedfile?.id) {
            return;
        }

        const uploadedFileId = notification.object.uploadedfile.id;
        const transcriptContainer = $(`.transcript-container[data-uploadedfile-id="${uploadedFileId}"]`);
        if (transcriptContainer.length === 0) {
            return;
        }

        if (!notification.object?.progress) {
            return;
        }

        if (transcriptContainer.hasClass('d-none')) {
            howspace.animate(transcriptContainer, 'slideDown', 350, () => {
                transcriptContainer.removeClass('d-none');
            });
        }

        if (!transcriptContainer.find('.transcript-content-wrapper').hasClass('d-none')) {
            howspace.animate(transcriptContainer.find('.transcript-content-wrapper'), 'slideUp', 350, () => {
                transcriptContainer.find('.transcript-content-wrapper').addClass('d-none');
                howspace.animate(transcriptContainer.find('.transcript-progress-wrapper'), 'slideDown', 350, () => {
                    transcriptContainer.find('.transcript-progress-wrapper').removeClass('d-none');
                });
            });
        }

        transcriptContainer.find('.transcribe-label .howspace-form-label-text span').text(howspace.translate('transcript_transcribe_in_progress'));

        const progress = notification.object.progress || 0;

        const progressBar = transcriptContainer.find('.transcript-progress');
        if (progressBar.length === 0) {
            return;
        }

        howspace.components.progress.update(progressBar, progress);
    });

})();
